import React, { useState } from 'react';
import { defaultPitchBreakdownFilter } from 'yankees-react-utils';
import { useTranslation } from 'react-i18next';
import Header from './Header';
import Filters from './Filters';
import PitchTabs from './PitchTabs';
import { PitchingBreakdown } from '../../../../data/data';
import PitchCharts from './PitchCharts';
import usePlayerSelector from '../../../../utils/usePlayerSelector';
import { useOktaQuery } from '../../../../data';

const convertFilterToPitchFX = (filter) => {
    let pitcherRole = null;
    switch (filter.pitcherRole) {
    case 1:
        pitcherRole = 1;
        break;
    case 2:
        pitcherRole = 0;
        break;
    default:
        pitcherRole = null;
    }
    let batterHand = null;
    switch (filter.batterHand) {
    case 1:
        batterHand = 0;
        break;
    case 2:
        batterHand = 1;
        break;
    default:
        batterHand = null;
    }
    let counts = null;
    const countArr = ['0', '10', '20', '30', '1', '11', '21', '31', '2', '12', '22', '32'];
    switch (filter.counts.join()) {
    case '-2':
        counts = '(0,10,20,30,1,11,21,31)';
        break;
    case '-3':
        counts = '(2,12,22,32)';
        break;
    case '-1':
        counts = null;
        break;
    default:
        counts = `(${filter.counts.map((x) => countArr[x]).join()})`;
    }
    return {
        baseState: filter.baseState === -1 ? null : filter.baseState,
        counts,
        result: filter.result.indexOf(-1) >= 0 ? null : filter.result,
        batterHand,
        zoneLocation: filter.zoneLocation === -1 ? null : filter.zoneLocation,
        pitchLocation: filter.pitchLocation.length > 0 ? filter.pitchLocation.map((rec) => (10 * rec.locationx) + rec.locationy) : null,
        pitcherRole,
        levelIds: filter.levelIds,
        startDate: filter.startDate,
        endDate: filter.endDate,
    };
};

const PitchComparison = () => {
    const { t: translate } = useTranslation();
    const { PlayerID, Throws, IsCatcher } = usePlayerSelector();

    const [filter, setFilter] = useState(defaultPitchBreakdownFilter);
    const [levels, setLevels] = useState([]);

    const pitcherId = IsCatcher ? filter.pitcher?.PlayerID : PlayerID;

    const { data: pitchComparison, isLoading: isLoadingPitchComparison } = useOktaQuery(
        ['pitchComparison', pitcherId, filter],
        (t) => PitchingBreakdown.getPitchComparison(t, {
            ...convertFilterToPitchFX(filter),
            PlayerID: pitcherId,
        }),
        { enabled: !!pitcherId && !!levels?.length, cacheTime: 0 },
    );
    const leagueAverageFilter = {
        ...convertFilterToPitchFX(filter),
        PlayerID: null,
        levelIds: [8],
        islhp: Throws === 2,
    };
    const { data: pitchComparisonLeagueAverage, isLoading: isLoadingPitchComparisonLeagueAverage } = useOktaQuery(
        ['pitchComparisonAverages', leagueAverageFilter],
        (t) => PitchingBreakdown.getPitchComparison(t, leagueAverageFilter),
        { enabled: !!pitcherId && !!levels?.length, cacheTime: 0 },
    );

    const allPitchTypes = [
        ...(pitchComparison?.pitchtypes ?? []),
        ...(pitchComparisonLeagueAverage?.pitchtypes ?? []),
    ];
    return (
        <div>
            <Header filter={filter} setFilter={setFilter} levels={levels} setLevels={setLevels} />
            {pitcherId ? (
                <>
                    <Filters filter={filter} setFilter={setFilter} />
                    <PitchTabs
                        className="mt-3"
                        isLoading={isLoadingPitchComparison}
                        pitchTypes={allPitchTypes}
                        isLhp={Throws === 2}
                        isLoadingAvg={isLoadingPitchComparisonLeagueAverage}
                    />
                    <PitchCharts
                        className="mt-3"
                        isLoading={isLoadingPitchComparison}
                        pitchTypes={pitchComparison?.pitchtypes.filter((pt) => pt.strikes === -1 && pt.balls === -1 && pt.pitchtype > 1) ?? []}
                        pitches={pitchComparison?.pitches ?? []}
                    />
                </>
            ) : <div className="text-center py-4 px-3 mt-3">{translate('sections.reports.pitcher.use-filters')}</div>}
        </div>
    );
};

export default PitchComparison;
